import {
  useV2CreateProjectVariableMutation,
  useV2UpdateProjectVariableMutation,
  useV2DeleteProjectVariableMutation,
  useV2RestoreProjectVariableByIdMutation,
  useV2PurgeProjectVariableByIdMutation,
  useV2ChangeProjectVariablePositionByIdMutation,
} from "@generated";
import type { UserDefinedFieldFormValues } from "../types/UserDefinedField";

const udfAttributes = (values: UserDefinedFieldFormValues): any => ({
  label: values.label,
  name: values.name,
  "variable-type": values.variableType,
  "variable-context": values.context,
  required: values.required,
  minimum: values.minimum,
  maximum: values.maximum,
  "select-options": values.selectOptions,
});

export const useUserDefinedFieldMutations = () => {
  const [create, createState] = useV2CreateProjectVariableMutation();
  const [update, updateState] = useV2UpdateProjectVariableMutation();
  const [destroy, destroyState] = useV2DeleteProjectVariableMutation();
  const [restore, restoreState] = useV2RestoreProjectVariableByIdMutation();
  const [purge, purgeState] = useV2PurgeProjectVariableByIdMutation();
  const [move, moveState] = useV2ChangeProjectVariablePositionByIdMutation();

  return {
    create: (values: UserDefinedFieldFormValues) =>
      create({
        body: {
          data: {
            type: "project-variables",
            attributes: udfAttributes(values),
          },
        },
      }).unwrap(),

    update: (id: string, values: UserDefinedFieldFormValues) =>
      update({
        id: id,
        body: {
          data: {
            type: "project-variables",
            id: id,
            attributes: udfAttributes(values),
          },
        },
      }).unwrap(),

    destroy: (id: string) => destroy({ id: id }).unwrap(),
    restore: (id: string) => restore({ id: id }).unwrap(),
    purge: (id: string) => purge({ id: id }).unwrap(),
    move: (id: string, position: number) =>
      move({
        id: id,
        body: {
          data: {
            type: "project-variables",
            id: id,
            attributes: { position },
          },
        } as Parameters<typeof move>[0]["body"],
      }).unwrap(),

    states: {
      createState,
      updateState,
      destroyState,
      restoreState,
      purgeState,
      moveState,
    },
  };
};
